import { useQuery } from '@tanstack/react-query'
import {
  GetTemplatesV2Request,
  Template,
  TemplatesApi,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'

const relatedTemplatesQueryKeys = {
  byMultipleChoiceGroup: (multipleChoiceGroupId: number | undefined) =>
    [
      'relatedTemplates',
      'byMultipleChoiceGroup',
      multipleChoiceGroupId,
    ] as const,
}

/**
 * 選択肢グループを使用している関連ひな形を取得する
 */
export const useQueryRelatedTemplates = (
  multipleChoiceGroupId: number | undefined,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: relatedTemplatesQueryKeys.byMultipleChoiceGroup(
      multipleChoiceGroupId,
    ),
    queryFn: async (): Promise<Template[]> => {
      if (!multipleChoiceGroupId) {
        return []
      }

      const params: GetTemplatesV2Request = {
        templateFilter: {
          multipleChoiceGroupId: {
            $in: [multipleChoiceGroupId],
          },
        },
      }

      const response = await baseClient
        .getApi(TemplatesApi)
        .getTemplatesV2(params)
        .catch(handleHTTPError)

      return response.templates || []
    },
    enabled,
    staleTime: 0,
  })
}
